export class FilesUtils {
  static convertFileListToFileArray(files: FileList) {
    const fileArray = [];
    for (let i = 0; i < files.length; i++) {
      fileArray.push(files[i]);
    }
    return fileArray;
  }
}
